import { Box, BoxProps } from "@chakra-ui/react";

interface DotProps extends BoxProps {
	color: string;
}

export function Dot({ color, ...props }: DotProps) {
	return (
		<Box
			width="14px"
			height="14px"
			borderRadius="4px"
			bgColor={color}
			borderWidth="1px"
			borderColor="#fff"
			{...props}
		/>
	);
}
